import {EventBus} from '@/common/helpers/utils/EventBus';

/**
 * Detects device "wake up" - exit from sleep (hibernation)
 */
export class WakeUpDetector {
	readonly onWakeUp = new EventBus();

	private worker?: Worker;

	initialize() {
		this.worker = new Worker(
			/* WebpackChunkName: "wakeup-detector-worker" */ new URL('./wakeUpWorker', import.meta.url),
		);
		this.worker.onmessage = event => {
			if (event.data === 'wakeUp') {
				this.onWakeUp.emit();
			}
		};
	}
}
